import {
  ButtonGroup,
  DialogActions,
  DialogContent,
  DialogTitle,
  Paper,
  Typography,
} from "@material-ui/core";

/**
 * ダイアログの表示コンポーネントです。<br />
 * `Dialog`コンポーネントに包んで使います。
 */
export const DialogPaper: React.FC<{
  title: string;
  message: string;
  buttonGroup: React.ReactNode;
}> = ({ title, message, buttonGroup }) => {
  return (
    <Paper>
      <DialogTitle>
        <Typography variant="h5">{title}</Typography>
      </DialogTitle>
      <DialogContent>
        <Typography>{message}</Typography>
      </DialogContent>
      <DialogActions>
        <ButtonGroup>{buttonGroup}</ButtonGroup>
      </DialogActions>
    </Paper>
  );
};
